<template>
  <div class="service-right">
    <div class="service-swiperImg">
      <div class="service-swiper-imgs">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide>
            <div class="service-swiper-img">
              <img src="../../static/img/pro4.2.jpg" alt="" />
            </div>
            <div class="service-swiper-text">
              <p>在线电子交易合同+运费在线支付，</p>
              <p>简单便捷，减少纠纷！</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="service-swiper-img">
              <img src="../../static/img/pro3.jpg" alt="" />
            </div>
            <div class="service-swiper-text">
              <p>船舶轨迹+船舶偏航提醒，</p>
              <p>从此云淡风轻，笑对江湖!</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="service-swiper-img">
              <img src="../../static/img/pro2.2.jpg" alt="" />
            </div>
            <div class="service-swiper-text">
              <p>7x24小时专属客服+运单状态完全展示，</p>
              <p>您的专属航运大管家!</p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="service-swiper-button" ref="swiperbtn">
        <div class="swiper-button-prev service-prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="swiper-button-next service-next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // noSwiping: true,
        // noSwipingSelector: '.swiper-slide',
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    imgHeight() {
      let imgHeight = this.$refs.el.offsetHeight;
      console.log(imgHeight);
      this.$refs.swiperbtn.style.bottom = imgHeight + "px";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.imgHeight();
    });
    // this.$refs.mySwiper.swiper.params.noSwiping = false
  },
};
</script>
<style scoped="scoped">
.service-right {
  width: 720px;
  height: 100%;
}
.service-swiper-img {
  width: 720px;
  height: 500px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service-swiper-imgs {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.service-swiper-text {
  font-size: 24px;
  line-height: 40px;
  padding: 50px 40px;
}
.service-swiperImg {
  position: relative;
}
.service-swiper-button {
  width: 140px;
  height: 70px;
  position: absolute;
  right: -70px;
  display: flex;
  z-index: 10;
  bottom: 0;
}
.swiper-button-next,
.swiper-button-prev {
  width: 70px;
  height: 70px;
  position: static;
  margin-top: 0;
  background-color: #f4f4f6;
  outline: none;
  font-size: 35px;
  color: #adadb0;
  font-weight: bold;
  transition: 0.3s;
  opacity: 1 !important;
  background-image: url();
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-button-next {
  background-color: #127bfd;
  color: #fff;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  content: "";
}
.service-swiperText {
  padding: 90px 0 0 40px;
}
.service-swiperText p {
  line-height: 40px;
  font-size: 24px;
  color: #282828;
}

@media only screen and (max-width: 1600px) {
  .service-swiper-img {
    width: 100%;
    height: auto;
  }
  .service-swiper-img img {
    width: 100%;
  }
  .service-right {
    width: 50%;
    padding-left: 20px;
  }
  .service-swiper-button {
    /* right: 0; */
  }
  .service-swiper-text {
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/serviceBanner.vue